import { render, staticRenderFns } from "./v5.vue?vue&type=template&id=b970bac0&scoped=true&"
import script from "./v5.vue?vue&type=script&lang=js&"
export * from "./v5.vue?vue&type=script&lang=js&"
import style0 from "./v5.vue?vue&type=style&index=0&id=b970bac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b970bac0",
  null
  
)

export default component.exports